module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "part_1"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "6.2em",
      "font-size": ".8em",
      "font-weight": "normal"
    },
    attrs: {
      "id": "pt1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/08_contents#toc-pt1"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "-.5em",
      "margin-bottom": "1em",
      "font-size": "1.3em",
      "font-weight": "normal"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/08_contents#toc-pt1"
    }
  }, [_vm._v("APPRENTICESHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "2.5em"
    }
  }, [_vm._v("So ignorant are most landsmen of some "), _c('br'), _vm._v("of the plainest and most palpable wonders "), _c('br'), _vm._v("of the world, that without some hints "), _c('br'), _vm._v("touching the plain facts, historical and "), _c('br'), _vm._v("otherwise, of the fishery, they might scout "), _c('br'), _vm._v("at Moby Dick as a monstrous fable, or "), _c('br'), _vm._v("still worse and more detestable, a hideous "), _c('br'), _vm._v("and intolerable allegory.")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_c('em', [_vm._v("Moby Dick")])]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "1.6em",
      "font-size": "1.2em",
      "font-weight": "normal",
      "page-break-before": "always !important"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("HOW A SUBMARINE DIVES")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1.4em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/part1-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("A submarine dives by allowing her main ballast tanks to fill with water. In the above diagrams (side view and bird’s-eye view) the main ballast tanks are indicated by shading. These tanks are outside the pressure-hull. On the surface they are full of air; when the air is allowed to escape, through vents at the top of the tanks, the sea comes in through holes at the bottom, and the submarine loses its buoyancy and dives. Under water the ship is controlled by internal trimming tanks and hydroplanes. The hydroplanes, which can be seen in the lower of the two diagrams above, are external fins which can be tilted from the control-room, one pair for’ard and one pair aft; they are really horizontal rudders.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The diagram below shows the centre cross-section of a submarine diving: (1) on the surface, ballast tanks full of air; (2) starting to dive, main vents open, air escaping and sea entering the tanks; (3) fully submerged, tanks full of water, main vents now shut ready for surfacing when necessary. To surface, compressed air is released into the tanks, forcing the water out through the bottom holes.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "margin-top": "2em",
      "margin-bottom": "1em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/part1-2.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e94fa95","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/10_part_1.vue
// module id = 87
// module chunks = 0